import { isString } from "../../validate"

export const charsForStartForbid = /^[&＆%％+＋=＝@＠;；|｜-]+$/
export const charsForInputReg = /^[A-Za-z0-9\u2018\u2019\'\"“”\[\]$&+,:=?@#|’<>.\-_^*()%!/~^`{}\s]*$/
export const charsForInputChineseReg =
  /^[a-zA-Z\u3105-\u3129\u02CA\u02C7\u02CB\u02D9\u4e00-\u9fa5"“””“”“\[\]［］$＄&＆+＋,，、:：=＝?？@＠#＃|｜‘’<＜>＞.。「」《》．・·＼\-－——_＿\^＾*＊(（)）%％!！/／~～()‘｀‘’'`{}｛｝「」\d\r\n\s 　]*$/

// Reject emoji (supplementary plane emoji + BMP pictographs + VS16 + ZWJ)
export const EMOJI_REGEX = /[\u{1F000}-\u{1FFFF}\u{2600}-\u{27BF}\u{2300}-\u{23FF}\u{2B00}-\u{2BFF}]|\u{FE0F}|\u{200D}/u

// Reject only fullwidth Latin letters + fullwidth digits (keeps fullwidth punctuation)
// U+FF10-U+FF19 = ０-９   U+FF21-U+FF3A = Ａ-Ｚ   U+FF41-U+FF5A = ａ-ｚ
export const FULLWIDTH_ALPHANUM_REGEX = /[\uFF10-\uFF19\uFF21-\uFF3A\uFF41-\uFF5A]/

export const containsEmoji = (str) => isString(str) && EMOJI_REGEX.test(str)
export const containsFullwidthAlphanum = (str) => isString(str) && FULLWIDTH_ALPHANUM_REGEX.test(str)

export const isInputText = (str) => {
  if (!isString(str)) return false
  if (!str.trim().length) return false
  if (containsEmoji(str)) return false
  if (containsFullwidthAlphanum(str)) return false
  if (str.slice(0, 1).match(charsForStartForbid)) return false
  return str.match(charsForInputReg) ? true : false
}

export const isChineseInputText = (str) => {
  if (!isString(str)) return false
  if (!str.trim().length) return false
  if (containsEmoji(str)) return false
  if (containsFullwidthAlphanum(str)) return false
  if (str.slice(0, 1).match(charsForStartForbid)) return false
  return str.match(charsForInputChineseReg) ? true : false
}
